import React from 'react';
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import Slide2Img from "./slideimg/slide2.png"


const Slide2 = () => {
  const slide2Style = css`
    width: 60vw;
    box-shadow: 5px 5px 20px 5px #123456;
    border-radius:25px;
  `;


  return (
    <div>
      <img src={Slide2Img} css={slide2Style}></img>
        <p>
          まず最初の画面でアイテムを装備します。
        </p>
    </div>
  )
}

export default Slide2